// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root,
.app,
.content {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  font-family: "Source Sans Pro", sans-serif;
}

.app {
  display: flex;
  position: relative;
}

::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #e0e0e0;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}


/* Videochat */
/* 
* {
  margin: 0;
  padding: 0;
} */

.videos_portal_styles {
  margin-left: 25%;
  width: 50%;
  height: calc(100vh - 25%);
  left: 0;
  top: 10%;
  position: absolute;
  display: flex;
  flex-wrap: wrap;
}

.room_container {
  width: 100%;
  height: 100vh;
  display: flex;
}

.chat_section_container {
  height: 100%;
  width: 20%;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.chat_label_container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.chat_label_paragraph {
  font-weight: 700;
  color: #9ca5ab;
  margin-left: 40px;
  font-size: 16px;
}

.new_message_container {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.new_message_input {
  border: 1px solid #d1dbe2;
  border-radius: 60px;
  padding: 0 20px;
  height: 60px;
  font-size: 16px;
  width: 80%;
  box-shadow: 2px 20px 5px rgba(0, 82, 201, 0.05);
}

.new_message_textarea:focus {
  outline: none;
}

.new_message_button {
  position: absolute;
  right: 10%;
}

.messages_container {
  width: calc(100% - 70px);
  margin-left: 30px;
  margin-right: 30px;
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: scroll;
}

.message_container {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
}

.message_align_left {
  align-items: flex-start;
}

.message_align_right {
  align-items: flex-end;
}

.message_left_styles {
  background: rgba(0, 82, 201, 0.1);
  color: black;
}

.message_right_styles {
  background: linear-gradient(168.68deg, #0052c9 1.12%, #0a91db 100%);
  color: white;
}

.message_title {
  margin: 0 0 10px 0;
  padding: 0 10px;
  color: black;
  font-size: 16px;
  font-weight: 500;
  display: block;
}

.message_content {
  margin: 0px 10px;
  padding: 10px 30px 10px 20px;
  border-radius: 25px;
  font-size: 16px;
  display: inline-block;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
  background: rgba(0, 188, 164, 0.1);
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #e5e5e5;
  border-radius: 10px;
}

.overlay_container {
  width: 100%;
  height: 100vh;
  background: rgba(0, 82, 201, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 2;
}

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #0052c9; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.participants_container {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-content: flex-start;
  height: 50%;
}

.direct_chat_container {
  height: 45%;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
}

.direct_chat_header {
  height: 50px;
  background: linear-gradient(168.68deg, #0052c9 1.12%, #0a91db 100%);
  width: 95%;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.direct_chat_header_paragraph {
  color: white;
  font-size: 16px;
}

.new_message_direct_border {
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  width: 95%;
}

.direct_messages_container {
  flex-grow: 1;
  width: 95%;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
}

.participants_paragraph {
  color: black;
  text-align: start;
  font-weight: 500;
  margin-left: 40px;
  transition: 0.5s;
  margin: 0 40px;
  padding: 10px 0px;
}

.participants_paragraph:hover {
  background-color: #e5e5e5;
  border-radius: 8px;
}

.participants_separator_line {
  width: calc(100% - 80px);
  height: 2px;
  background-color: #e5e5e5;
  margin-left: 40px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.participants_section_container {
  height: 100%;
  width: 20%;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.participants_label_container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.participants_label_paragraph {
  font-weight: 700;
  color: #9ca5ab;
  margin-left: 40px;
  font-size: 16px;
}

.local_screen_share_preview {
  position: absolute;
  width: 15%;
  height: 90%;
  background-color: black;
  border-radius: 8px;
  border: 2px solid blue;
  left: 1%;
  bottom: 1%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video_buttons_container {
  width: 60%;
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 20%;
  bottom: 0;
  background: linear-gradient(168.68deg, #0052c9 1.12%, #0a91db 100%);
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}

.video_button_container {
  margin-left: 25px;
  display: flex;
  flex-direction: column;
}

.video_button_image {
  height: 80%;
  padding: 10px;
  border-radius: 25px;
  transition: 0.3s;
}

.video_button_image:hover {
  background: blue;
  padding: 10px;
  border-radius: 25px;
}

.video_button_end {
  width: 200px;
  height: 60px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 65px;
  border: none;
  color: white;
  background: #fc5d5b;
  box-shadow: 0px 3px 30px rgba(252, 93, 91, 0.1);
  transition: 0.2s;
}

.video_button_end:hover {
  background: red;
}

.videos_container {
  height: 90%;
  width: 100%;
  background-color: #f6f9fb;
  position: relative;
  border-radius: 0px 0px 25px 25px;
}

.participants {
  display: flex;
  width: 100%;
  height: 100%;
}

.participant {
  flex-grow: 1;
}

/* .identity {
        position: absolute;
        left: 0px;
        bottom: 15px;
        color: white;
        padding-left: 15px;
        box-sizing: border-box;
        z-index: 10;
      } */

.video {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
}

.screen_share_track {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 2;
  top: 0;
  left: 0;
}

.room {
  width: 100%;
  height: 100%;
}

video {
  width: 98%;
  height: 98%;
}

.room_label {
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: center;
  z-index: 4;
}

.room_label_paragraph {
  font-size: 17px;
  color: white;
  margin-top: 0;
  padding: 18px 38px;
  background: linear-gradient(168.68deg, #0052c9 1.12%, #0a91db 100%);
  border-radius: 0px 0px 15px 15px;
}

.video_track_container:first-child:nth-last-child(1) {
  width: 100%;
  height: 100%;
  position: relative;
}

.video_track_container:first-child:nth-last-child(2),
.video_track_container:first-child:nth-last-child(2) ~ .video_track_container {
  width: 50%;
  height: 50%;
  position: relative;
}

.video_track_container:first-child:nth-last-child(3),
.video_track_container:first-child:nth-last-child(3) ~ .video_track_container {
  width: 50%;
  height: 50%;
  position: relative;
}

.video_track_container:first-child:nth-last-child(4),
.video_track_container:first-child:nth-last-child(4) ~ .video_track_container {
  width: 50%;
  height: 50%;
  position: relative;
}

.video_track_container:first-child:nth-last-child(5),
.video_track_container:first-child:nth-last-child(5) ~ .video_track_container {
  width: 33%;
  height: 33%;
  position: relative;
}

.video_track_container:first-child:nth-last-child(6),
.video_track_container:first-child:nth-last-child(6) ~ .video_track_container {
  width: 33%;
  height: 33%;
}

.video_track_container:first-child:nth-last-child(7),
.video_track_container:first-child:nth-last-child(7) ~ .video_track_container {
  width: 33%;
  height: 33%;
}

.video_track_container:first-child:nth-last-child(8),
.video_track_container:first-child:nth-last-child(8) ~ .video_track_container {
  width: 33%;
  height: 33%;
}

.video_track_container:first-child:nth-last-child(9),
.video_track_container:first-child:nth-last-child(9) ~ .video_track_container {
  width: 33%;
  height: 33%;
}

.video_section_container {
  height: 100%;
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.full_screen {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0%;
  left: 0%;
}

.label_only_audio_container {
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0%;
  left: 0%;
}

.label_only_audio_container {
  font-size: 18px;
  color: black; 
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;;;;EAKE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;;AAGA,cAAc;AACd;;;;GAIG;;AAEH;EACE,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,mEAAmE;EACnE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0BAA0B,EAAE,eAAe;EAC3C,8BAA8B,EAAE,SAAS;EACzC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mEAAmE;EACnE,UAAU;EACV,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,mEAAmE;EACnE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;;SAQS;;AAET;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,MAAM;EACN,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mEAAmE;EACnE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap\");\n\nhtml,\nbody,\n#root,\n.app,\n.content {\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden;\n  font-family: \"Source Sans Pro\", sans-serif;\n}\n\n.app {\n  display: flex;\n  position: relative;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #e0e0e0;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n\n/* Videochat */\n/* \n* {\n  margin: 0;\n  padding: 0;\n} */\n\n.videos_portal_styles {\n  margin-left: 25%;\n  width: 50%;\n  height: calc(100vh - 25%);\n  left: 0;\n  top: 10%;\n  position: absolute;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.room_container {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n}\n\n.chat_section_container {\n  height: 100%;\n  width: 20%;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n}\n\n.chat_label_container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.chat_label_paragraph {\n  font-weight: 700;\n  color: #9ca5ab;\n  margin-left: 40px;\n  font-size: 16px;\n}\n\n.new_message_container {\n  width: 100%;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.new_message_input {\n  border: 1px solid #d1dbe2;\n  border-radius: 60px;\n  padding: 0 20px;\n  height: 60px;\n  font-size: 16px;\n  width: 80%;\n  box-shadow: 2px 20px 5px rgba(0, 82, 201, 0.05);\n}\n\n.new_message_textarea:focus {\n  outline: none;\n}\n\n.new_message_button {\n  position: absolute;\n  right: 10%;\n}\n\n.messages_container {\n  width: calc(100% - 70px);\n  margin-left: 30px;\n  margin-right: 30px;\n  flex-grow: 1;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n\n.message_container {\n  margin-top: 5px;\n  display: flex;\n  flex-direction: column;\n}\n\n.message_align_left {\n  align-items: flex-start;\n}\n\n.message_align_right {\n  align-items: flex-end;\n}\n\n.message_left_styles {\n  background: rgba(0, 82, 201, 0.1);\n  color: black;\n}\n\n.message_right_styles {\n  background: linear-gradient(168.68deg, #0052c9 1.12%, #0a91db 100%);\n  color: white;\n}\n\n.message_title {\n  margin: 0 0 10px 0;\n  padding: 0 10px;\n  color: black;\n  font-size: 16px;\n  font-weight: 500;\n  display: block;\n}\n\n.message_content {\n  margin: 0px 10px;\n  padding: 10px 30px 10px 20px;\n  border-radius: 25px;\n  font-size: 16px;\n  display: inline-block;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 5px;\n  background: rgba(0, 188, 164, 0.1);\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 10px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #e5e5e5;\n  border-radius: 10px;\n}\n\n.overlay_container {\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 82, 201, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  z-index: 2;\n}\n\n.loader {\n  border: 16px solid #f3f3f3; /* Light grey */\n  border-top: 16px solid #0052c9; /* Blue */\n  border-radius: 50%;\n  width: 120px;\n  height: 120px;\n  animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.participants_container {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-content: flex-start;\n  height: 50%;\n}\n\n.direct_chat_container {\n  height: 45%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n}\n\n.direct_chat_header {\n  height: 50px;\n  background: linear-gradient(168.68deg, #0052c9 1.12%, #0a91db 100%);\n  width: 95%;\n  border-top-left-radius: 25px;\n  border-top-right-radius: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.direct_chat_header_paragraph {\n  color: white;\n  font-size: 16px;\n}\n\n.new_message_direct_border {\n  border-left: 1px solid #e5e5e5;\n  border-right: 1px solid #e5e5e5;\n  width: 95%;\n}\n\n.direct_messages_container {\n  flex-grow: 1;\n  width: 95%;\n  border-left: 1px solid #e5e5e5;\n  border-right: 1px solid #e5e5e5;\n}\n\n.participants_paragraph {\n  color: black;\n  text-align: start;\n  font-weight: 500;\n  margin-left: 40px;\n  transition: 0.5s;\n  margin: 0 40px;\n  padding: 10px 0px;\n}\n\n.participants_paragraph:hover {\n  background-color: #e5e5e5;\n  border-radius: 8px;\n}\n\n.participants_separator_line {\n  width: calc(100% - 80px);\n  height: 2px;\n  background-color: #e5e5e5;\n  margin-left: 40px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.participants_section_container {\n  height: 100%;\n  width: 20%;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n}\n\n.participants_label_container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.participants_label_paragraph {\n  font-weight: 700;\n  color: #9ca5ab;\n  margin-left: 40px;\n  font-size: 16px;\n}\n\n.local_screen_share_preview {\n  position: absolute;\n  width: 15%;\n  height: 90%;\n  background-color: black;\n  border-radius: 8px;\n  border: 2px solid blue;\n  left: 1%;\n  bottom: 1%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video_buttons_container {\n  width: 60%;\n  height: 10%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: 20%;\n  bottom: 0;\n  background: linear-gradient(168.68deg, #0052c9 1.12%, #0a91db 100%);\n  border-top-left-radius: 25px;\n  border-top-right-radius: 25px;\n}\n\n.video_button_container {\n  margin-left: 25px;\n  display: flex;\n  flex-direction: column;\n}\n\n.video_button_image {\n  height: 80%;\n  padding: 10px;\n  border-radius: 25px;\n  transition: 0.3s;\n}\n\n.video_button_image:hover {\n  background: blue;\n  padding: 10px;\n  border-radius: 25px;\n}\n\n.video_button_end {\n  width: 200px;\n  height: 60px;\n  font-size: 18px;\n  font-weight: 600;\n  border-radius: 65px;\n  border: none;\n  color: white;\n  background: #fc5d5b;\n  box-shadow: 0px 3px 30px rgba(252, 93, 91, 0.1);\n  transition: 0.2s;\n}\n\n.video_button_end:hover {\n  background: red;\n}\n\n.videos_container {\n  height: 90%;\n  width: 100%;\n  background-color: #f6f9fb;\n  position: relative;\n  border-radius: 0px 0px 25px 25px;\n}\n\n.participants {\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n.participant {\n  flex-grow: 1;\n}\n\n/* .identity {\n        position: absolute;\n        left: 0px;\n        bottom: 15px;\n        color: white;\n        padding-left: 15px;\n        box-sizing: border-box;\n        z-index: 10;\n      } */\n\n.video {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.screen_share_track {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  top: 0;\n  left: 0;\n}\n\n.room {\n  width: 100%;\n  height: 100%;\n}\n\nvideo {\n  width: 98%;\n  height: 98%;\n}\n\n.room_label {\n  position: absolute;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  z-index: 4;\n}\n\n.room_label_paragraph {\n  font-size: 17px;\n  color: white;\n  margin-top: 0;\n  padding: 18px 38px;\n  background: linear-gradient(168.68deg, #0052c9 1.12%, #0a91db 100%);\n  border-radius: 0px 0px 15px 15px;\n}\n\n.video_track_container:first-child:nth-last-child(1) {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.video_track_container:first-child:nth-last-child(2),\n.video_track_container:first-child:nth-last-child(2) ~ .video_track_container {\n  width: 50%;\n  height: 50%;\n  position: relative;\n}\n\n.video_track_container:first-child:nth-last-child(3),\n.video_track_container:first-child:nth-last-child(3) ~ .video_track_container {\n  width: 50%;\n  height: 50%;\n  position: relative;\n}\n\n.video_track_container:first-child:nth-last-child(4),\n.video_track_container:first-child:nth-last-child(4) ~ .video_track_container {\n  width: 50%;\n  height: 50%;\n  position: relative;\n}\n\n.video_track_container:first-child:nth-last-child(5),\n.video_track_container:first-child:nth-last-child(5) ~ .video_track_container {\n  width: 33%;\n  height: 33%;\n  position: relative;\n}\n\n.video_track_container:first-child:nth-last-child(6),\n.video_track_container:first-child:nth-last-child(6) ~ .video_track_container {\n  width: 33%;\n  height: 33%;\n}\n\n.video_track_container:first-child:nth-last-child(7),\n.video_track_container:first-child:nth-last-child(7) ~ .video_track_container {\n  width: 33%;\n  height: 33%;\n}\n\n.video_track_container:first-child:nth-last-child(8),\n.video_track_container:first-child:nth-last-child(8) ~ .video_track_container {\n  width: 33%;\n  height: 33%;\n}\n\n.video_track_container:first-child:nth-last-child(9),\n.video_track_container:first-child:nth-last-child(9) ~ .video_track_container {\n  width: 33%;\n  height: 33%;\n}\n\n.video_section_container {\n  height: 100%;\n  width: 60%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.full_screen {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0%;\n  left: 0%;\n}\n\n.label_only_audio_container {\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0%;\n  left: 0%;\n}\n\n.label_only_audio_container {\n  font-size: 18px;\n  color: black; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
